"use client"

import { useState, useEffect } from "react"
import { useLocation } from "react-router-dom"
import styles from "../styles/AboutUs.module.css"
import Footer from "../components/Footer"
import Header from "../components/Header"
import InvestorRelationViewer from "../pages/InvestorRelationViewer"
import CompanyProfileViewer from "../pages/CompanyProfileViewer"
import Investorpdf from "../assets/ArifDeck.pdf"
import companyPdf from "../assets/profile.pdf"

// Import all section components
import HeroSection from "../components/about/hero-section"
import TimelineSection from "../components/about/timeline-section"
import ValuesSection from "../components/about/values-section"
import AwardsSection from "../components/about/awards-section"
import TeamSection from "../components/about/team-section"
import SolutionsSection from "../components/about/solutions-section"
import PressReleasesSection from "../components/about/press-releases-section"
import CareersSection from "../components/about/careers-section"

const AboutUs = () => {
  const [showCompanyProfile, setShowCompanyProfile] = useState(false)
  const [showCompanyPdf, setShowCompanyPdf] = useState(false)
  const [showInvestorPdf, setShowInvestorPdf] = useState(false)
  const [showInvestorRelation, setShowInvestorRelation] = useState(false)

  const location = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location])

  // Handlers for PDF viewers
  const handleCompanyProfileClick = () => {
    setShowCompanyPdf(true)
  }
  const handleCloseCompanyPdf = () => {
    setShowCompanyPdf(false)
  }
  const handleInvestorClick = () => {
    setShowInvestorPdf(true)
  }
  const handleCloseInvestorPdf = () => {
    setShowInvestorPdf(false)
  }

  return (
    <div>
      <Header />
      <div className={styles.container} style={{ overflowX: "hidden" }}>
        <div className={styles.content} style={{ overflowX: "hidden" }}>
          {/* Hero Section */}
          <HeroSection
            showCompanyProfile={showCompanyProfile}
            setShowCompanyProfile={setShowCompanyProfile}
            showInvestorRelation={showInvestorRelation}
            setShowInvestorRelation={setShowInvestorRelation}
            handleCompanyProfileClick={handleCompanyProfileClick}
            handleInvestorClick={handleInvestorClick}
          />

          {/* PDF Viewers */}
          {showCompanyPdf && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0,0,0,0.8)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
              }}
            >
              <CompanyProfileViewer pdfPath={companyPdf} onClose={handleCloseCompanyPdf} />
            </div>
          )}

          {showInvestorPdf && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0,0,0,0.8)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
              }}
            >
              <InvestorRelationViewer pdfPath={Investorpdf} onClose={handleCloseInvestorPdf} />
            </div>
          )}

          <TimelineSection />
          <ValuesSection />       
          <AwardsSection />
          <TeamSection />
          <SolutionsSection />
          <PressReleasesSection />
          <CareersSection />

          <Footer />
        </div>
      </div>
    </div>
  )
}

export default AboutUs
